import Stat from '@fe/common/lib/stat';
import { getUrlPathname, sendStat } from 'utils/common';
import VARIABLES from 'constants/variable.json5';

// 访问量统计参数
const STAT_PARAMS = {
  [VARIABLES.RECOMMEND]: {
    id: 'web_mobanmarket_tuijian_preview',
    desc: '访问推荐-分类页面',
  },
  [VARIABLES.RP_H5]: {
    id: 'web_mobanmarket_changjing_preview',
    desc: '访问场景-分类页面',
  },
  [VARIABLES.RP_SPA]: {
    id: 'web_mobanmarket_changye_preview',
    desc: '访问长页-分类页面',
  },
  [VARIABLES.RP_VIDEO]: {
    id: 'web_mobanmarket_shipin_preview',
    desc: '访问视频-分类页面',
  },
  [VARIABLES.RP_GAME]: {
    id: 'web_mobanmarket_game_preview',
    desc: '访问小游戏-分类页面',
  },
  [VARIABLES.VIP]: {
    id: 'web_mobanmarket_vip_preview',
    desc: '访问vip专享-分类页面',
  },
  [VARIABLES.ENTERPRISE]: {
    id: 'web_mobanmarket_qiye_preview',
    desc: '访问企业专区-分类页面',
  },
  [VARIABLES.MY_TPL]: {
    id: 'web_mobanmarket_shoucang_preview',
    desc: '访问已收藏模板-分类页面',
  },
  total: {
    id: 'web_mobanmarket_all_preview',
    desc: '总访问量',
  },
};

// 统计各个tab访问量
export function sendTabsViewStat(category) {
  const statParams = STAT_PARAMS[category];
  if (statParams) {
    sendStat('RP_STORE', '模版市场', statParams.desc, Stat.ACTION_INIT, {
      id: statParams.id,
    });
  }
}

// 统计总访问量
export function sendTotalViewStat() {
  const statParams = STAT_PARAMS['total'];
  sendStat('RP_STORE', '模版市场', statParams.desc, Stat.ACTION_INIT, {
    id: statParams.id,
  });
}

// 统计模板市场访问量
export default function sendStoreViewStat(category) {
  const pathname = getUrlPathname();

  // 搜索结果页不进行访问量统计
  if (pathname === '/template/search.html') {
    return false;
  }

  sendTabsViewStat(category);
  sendTotalViewStat();
}
